import React, { useState, useMemo } from 'react';
import MaterialTable from 'material-table'
import { Fab, withStyles, Typography, IconButton, Tooltip } from '@material-ui/core';
import * as actions from './store/baseboardActions';
import * as action from '../../np-core/Auth/store/authActions';
import { connect } from 'react-redux';
import { Add, Delete, Refresh } from '@material-ui/icons';
import BaseboardDelete from './BaseboardDelete'
import { hasPermission, localization, hasAtLeastOnePermission, getDimensionsOfPagination } from '../../sc-utilities';
import Toolbar from '../../sc-utilities/Toolbar'
import { CsvBuilder } from 'filefy';
import { MuiTableRows } from '../../../themes';

const styles = theme => ({
    "@global": {
        "[class*='buttonsCustomer']": {
            margin: theme.spacing(),
            fontSize: '13px',
            width: '100%',
            '&:hover': {
                backgroundColor: theme.palette.secondary.main,
                color: theme.palette.buttonText.default
            },
        },
        "[class*='paletteButtons']": {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.buttonText.default,
            margin: theme.spacing(),
            '&:hover': {
                backgroundColor: theme.palette.secondary.main,
            },
        },
        "[class*='MuiTableCell-root MuiTableCell-body']": {
            height: "40px",
            padding: '2px',
            fontSize: '0.7rem'
        },
    },
    fab: {
        textTransform: "none",
        width: '50%',
        color: theme.palette.buttonText.default,
        marginLeft: theme.spacing(),
        backgroundColor: theme.palette.primary.main,
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        }
    },
    customToolbar: {
        marginTop: 15,
        marginLeft: 14,
        width: "900px"
    },
    tableTitle: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        overflow: 'visible',
    },
    customTooltip: {
        marginLeft: -16,
        marginTop: '-2px'
    },
    toolbar: {
        paddingTop: '1%'
    }
});
let pageSize = 100;
let rowsPageSizeInit = [20, 50, 100];

const BaseboardList = props => {
    const { classes, editable, translations, saveColumnsFilter, activeCustomer, permissions, tableColumns, onFetchBaseboardsCount, baseboards, onFetchBaseboards, onBulkDeleteBaseboards, handleOpen, tableRef } = props;
    const [deleteModalState, setDeleteModalState] = useState({ open: false, componentIDs: [] });

    const customExport = (columns, baseboardComponentList) => {
        if (columns && columns[0].field === 'Action') {
            columns.shift()
        }
        const data = baseboardComponentList.map(baseboardComponent => {
            let returnObj = [
                baseboardComponent.ComponentType ? baseboardComponent.ComponentType : translations['short_not_assigned'] || 'n/a',
                baseboardComponent.Vendor ? baseboardComponent.Vendor : translations['short_not_assigned'] || 'n/a',
                baseboardComponent.ComponentModel ? baseboardComponent.ComponentModel : translations['short_not_assigned'] || 'n/a',
                baseboardComponent.SerialNumber ? baseboardComponent.SerialNumber : translations['short_not_assigned'] || 'n/a',
                baseboardComponent.Description ? baseboardComponent.Description : translations['short_not_assigned'] || 'n/a',
                baseboardComponent.Deleted ? 'Yes' : 'No'
            ];
            return returnObj;
        });
        const builder = new CsvBuilder(`securaze_baseboard_${Math.floor(Date.now() / 1000)}.csv`);
        builder
            .setDelimeter('|')
            .setColumns(columns.map(columnDef => columnDef.title))
            .addRows(data)
            .exportFile();
    };

    const fetching = baseboards.fetching;
    const columnObject = useMemo(() => tableColumns
        // eslint-disable-next-line react-hooks/exhaustive-deps
        , []); const [tableOptions, setTableOptions] = useState({
            filtering: true,
            sorting: false,
            selection: hasAtLeastOnePermission(permissions, ["component_delete"]),
            search: false,
            minBodyHeight: window.innerHeight - 299 < 235 ? 235 : window.innerHeight - 299,
            maxBodyHeight: window.innerHeight - 299,
            pageSizeOptions: rowsPageSizeInit,
            exportCsv: customExport,
            exportButton: false,
            rowStyle: (_rowData, index) => {
                return { backgroundColor: index % 2 ? MuiTableRows.odd : MuiTableRows.even };
            },
            columnsButton: true,
            pageSize: pageSize ? pageSize : 50,
            emptyRowsWhenPaging: false
        });

    const handleBulkDelete = componentIDS => {
        if (!componentIDS) {
            setDeleteModalState({ open: false, componentID: null, componentIDs: [], forBulk: false });
            return;
        }
        setDeleteModalState({ ...deleteModalState, open: true, componentIDs: componentIDS, forBulk: true });
    };

    const tableActions = [
        {
            tooltip: `${translations["remove_all_selected"] || "Remove All Selected "} ${translations["baseboards"] || "baseboards "}`,
            icon: <Delete />,
            onClick: (rowData) => handleBulkDelete(rowData.map(baseboard => baseboard.ComponentID)),
            position: 'toolbarOnSelect',
        }
    ]

    const filterQuery = filters => {
        let obj = {};
        for (var filter of filters) {
            obj[filter.column.field] = filter.value;
        }
        obj['ComponentType'] = 'baseboard';
        obj['ProductID'] = props.productID;
        return obj;
    }

    async function fetchTableData(query) {
        let q = filterQuery(query.filters);

        query['ActiveCustomerID'] = activeCustomer;
        query['q'] = q;
        let count = await onFetchBaseboardsCount(query);
        if (!query['page'] && query['pageSize'] !== 20 && query['pageSize'] !== 100) {
            let dimensions = getDimensionsOfPagination(count)
            query['pageSize'] = dimensions.pageSize
            rowsPageSizeInit = dimensions.rowsPageSize
            pageSize = dimensions.pageSize
        }
        let result = count ? await onFetchBaseboards(query) : [];
        setTableOptions({ ...tableOptions, pageSize: query['pageSize'], pageSizeOptions: rowsPageSizeInit });
        return { data: result, page: query.page, pageSize: pageSize, totalCount: count };
    }

    const columnHidden = newColumnState => {
        let objToSendColumn = {}
        let objColumns = {}
        columnObject.map(column => {
            objColumns[`${column.field}`] = column.hidden
            return objColumns
        })
        objToSendColumn[`Baseboard`] = objColumns
        saveColumnsFilter({ ...objToSendColumn, ActiveCustomerID: activeCustomer })
        return newColumnState
    }

    const handleCloseDanger = async () => {
        await onBulkDeleteBaseboards({ ComponentIDs: deleteModalState.componentIDs, ActiveCustomerID: activeCustomer });
        handleBulkDelete();
        tableRef.current && tableRef.current.onQueryChange()
    }

    const tableTitle = () => {
        return <div className={classes.customToolbar}>
            <div className={classes.tableTitle}>
                <Typography className={classes.typography}>{translations["baseboards"] || "Baseboards"}</Typography>
                {hasPermission(permissions, "component_create") ? (
                    <Fab
                        variant="extended"
                        size="small"
                        color="primary"
                        aria-label="Add"
                        disabled={!editable}
                        className={classes.fab}
                        style={{ borderRadius: '1px' }}
                        onClick={handleOpen}
                    >
                        <Add size="small" />
                        {translations["create_new"] || "Create new"}
                    </Fab>

                ) : null}
                <Tooltip title={translations["refresh"] || "Refresh"}>
                    <IconButton aria-label={translations["refresh"] || "Refresh"} component="div" disabled={fetching} onClick={() => tableRef.current && tableRef.current.onQueryChange()}>
                        <Refresh />
                    </IconButton>
                </Tooltip>
            </div>
        </div>
    }

    return (<>
        <MaterialTable
            components={{
                Toolbar: props => (
                    <Toolbar data={props} classes={{ toolbar: classes.toolbar }} editable={!editable} actions={tableActions} selectedRows={props.selectedRows} translations={translations} />
                )
            }}
            localization={localization(translations)}
            tableRef={tableRef}
            title={tableTitle()}
            columns={columnObject}
            data={fetchTableData}
            options={tableOptions}
            isLoading={fetching}
            onChangeRowsPerPage={(size) => {
                pageSize = size
            }}
            onChangeColumnHidden={columnHidden}
            onChangePage={() => {if(tableRef?.current?.tableContainerDiv?.current) {tableRef.current.tableContainerDiv.current.scrollTop = 0}}}
        />
        {hasPermission(permissions, "component_delete") ? (
            <BaseboardDelete
                activeCustomer={activeCustomer}
                entityName={translations["baseboards"] || "Baseboards"}
                translations={translations}
                handleDelete={handleBulkDelete}
                handleCloseDanger={handleCloseDanger}
                deleteModalState={deleteModalState}
            />
        ) : null}

    </>)
}

const mapDispatchToProps = dispatch => {
    return {
        onFetchBaseboardsCount: filter => dispatch(actions.fetchBaseboardCount(filter)),
        onFetchBaseboards: filter => dispatch(actions.fetchBaseboard(filter)),
        saveColumnsFilter: data => dispatch(action.saveColumnsFilter(data)),
        onBulkDeleteBaseboards: nic => dispatch(actions.bulkDeleteBaseboards(nic))
    };
};

const mapStateToProps = state => {
    return {
        permissions: state?.core?.login?.permissions || [],
        activeCustomer: state?.core?.login?.activeCustomer?.CustomerID ?? null,
        baseboards: state.product.baseboards,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {}
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(BaseboardList));